module.exports = __webpack_public_path__ + "static/media/menu-toggle.8383b246.svg";